import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import OInputField from './OInputField'
import { apiGet } from 'utils/apiFetch'
import pathObj from 'utils/apiPath'
const BORDER_LIME_500 = 'border-lime-500 text-lime-500 bg-lime-100 '
const DEFAULT_AMENITIES_CLASSES =
  'truncate border rounded-full py-2 xl:py-3 px-5 xl:px-7 text-gray-700 flex items-center w-full'
const tabBtnClass =
  'inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2'
const tabActiveClass = 'border-lime-500 text-lime-500'
const tabBorderNoneClass = 'border-transparent'
const TAB_LIFESTYLE = 'lifestyle'
export const TAB_BUILDING = 'building'
export const TAB_UNIT = 'unit'

const TABS = {
  TAB_LIFESTYLE,
  TAB_BUILDING,
  TAB_UNIT,
}
const OAmenities = ({
  setIsAmenities,
  propertyAmenitiesList,
  propertyAmenities,
  setPropertyAmenities,
  setIsAmenity
}) => {
  const { t } = useTranslation()
  const [amenities, setAmenities] = useState( [])
  const handleAmenitiesClick = (amenity, e) => {
    if (propertyAmenities?.includes(amenity?._id)) {
      const selectedAmenities = propertyAmenities.filter(
        selectedOption => selectedOption !== amenity?._id
      )
      setPropertyAmenities(selectedAmenities)
      if (selectedAmenities?.length > 0) {
        setIsAmenity('')
      } else {
        setIsAmenity('Please select amenities.')
      }
    } else {
      const selectedAmenities = [...propertyAmenities, amenity?._id]
      setPropertyAmenities(selectedAmenities)
      if (selectedAmenities?.length > 0) setIsAmenity('')
    }
  }


  const getAmenityData = async type => {
    try {
      const payload = {}
      const path = pathObj.propertyAmenity+'/'+type
      const result = await apiGet(path, payload)
      const records = result?.data?.results
      setAmenities(records?.propertyAmenities || [])
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }

  const [defaultTab, setTab] = useState('lifestyle')
  const handleTabClick = (action, e) => {
    getAmenityData(action)
    setTab(action)
  }
  useEffect(() => {
    getAmenityData("lifestyle")
    window.scrollTo(0, 0)
  }, [])

  const handleChange = event => {
    if (event.target.value) {
      const filterAmenities = amenities?.filter(amenity =>
        amenity?.name
          ?.toLowerCase()
          ?.includes(event.target.value.toLowerCase().trim())
      )
      setAmenities(filterAmenities)
    } else {
      getAmenityData(defaultTab)
      //setAmenities(propertyAmenitiesList)
    }
  }
  return (
    <>
      <div className='justify-center items-center  overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative my-6 mx-auto w-[1250px]'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('Amenities')}</h3>
                <button
                  className=' text-base ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setIsAmenities(false)}
                >
                  <span
                    className=' text-[#B8BBBF]  text-4xl '
                    title={t('O_CLOSE')}
                  >
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-3 flex-auto overflow-auto'>
                <ul className='border-b flex'>
                  <li className='mr-0 xl:mr-5'>
                    <button
                      onClick={handleTabClick.bind(this, TAB_LIFESTYLE)}
                      className={classNames({
                        [tabBtnClass]: true,
                        [tabActiveClass]: defaultTab === TAB_LIFESTYLE,
                        [tabBorderNoneClass]: defaultTab !== TAB_LIFESTYLE
                      })}
                    >
                      {t('TAB_LIFESTYLE')}
                    </button>
                  </li>
                  <li className='mx-0 xl:mx-5'>
                    <button
                      onClick={handleTabClick.bind(this, TAB_BUILDING)}
                      className={classNames({
                        [tabBtnClass]: true,
                        [tabActiveClass]: defaultTab === TAB_BUILDING,
                        [tabBorderNoneClass]: defaultTab !== TAB_BUILDING
                      })}
                    >
                      {t('TAB_BUILDING')}
                    </button>
                  </li>
                  <li className='mx-0 xl:mx-5'>
                    <button
                      onClick={handleTabClick.bind(this, TAB_UNIT)}
                      className={classNames({
                        [tabBtnClass]: true,
                        [tabActiveClass]: defaultTab === TAB_UNIT,
                        [tabBorderNoneClass]: defaultTab !== TAB_UNIT
                      })}
                    >
                      {t('TAB_UNIT')}
                    </button>
                  </li>
                </ul>
              </div>
              <div className='relative p-3 flex-auto overflow-auto'>
                <OInputField
                  type='text'
                  // placeholder='Search Amenities'
                  inputLabel='Search Amenities'
                  autoFocus
                  onChange={handleChange}
                />
                <ul className='flex flex-wrap py-3 max-h-[600px] overflow-y-scroll'>
                  {amenities.map((amenity, index) => {
                    return (
                      <li
                        onClick={handleAmenitiesClick.bind(this, amenity)}
                        key={index}
                        className='mb-3 mr-2 text-md w-[calc(25%-10px)]'
                      >
                        <button
                          type='button'
                          className={classNames({
                            [DEFAULT_AMENITIES_CLASSES]: true,
                            [BORDER_LIME_500]: propertyAmenities?.includes(
                              amenity._id
                            )
                          })}
                        >
                          <span className='mr-2'>
                            <img
                              className='w-5 h-5'
                              src={amenity?.icon}
                              alt={amenity?.name}
                            />
                          </span>
                          {amenity?.name}
                        </button>
                      </li>
                    )
                  })}
                </ul>
                {!amenities?.length && (
                  <p className='text-center'>No Amenities found</p>
                )}
              </div>
              {amenities?.length !== 0 && (
                <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                  {/* <button
                        className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                        type='button'
                        onClick={() => setIsAmenities(false)}
                      >
                        {t('O_CLOSE')}
                      </button> */}
                  <button
                    className='bg-[#8FC150] text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                    type='submit'
                    onClick={() => setIsAmenities(false)}
                  >
                    {t('O_SUBMIT')}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default OAmenities
